import React, { useEffect, useState } from 'react'
import Layout from './Layout'
import Button from './ui/Button'
//import { CheckBadgeIcon as Check } from '@heroicons/react/24/solid'
import { Check, X, ChevronDown, CreditCard, Users, Building, Award, Crown } from "lucide-react"
import { IoMdPaper } from 'react-icons/io'
import { Fragment } from 'react'
import { CheckIcon, MinusIcon } from '@heroicons/react/20/solid'
import { useTranslation } from 'react-i18next'
import { set } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import useApiUrlTranslation from './useApiUrlTranslation'
import HTMLReactParser from 'html-react-parser'


const Coordinateur = () => {


    const { idContact } = useParams();

    const [contact, setContact] = useState(null);
    const [isLoading, setIsLoading] = useState(true);


    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const getContact = async () => {
        await fetch(`${apiUrlTranslation}?action=getContact&id_contact=${idContact}`)
            .then(res => res.json())
            .then(res => setContact(res))
    }

    useEffect(() => {
        getContact().then(() => {
            setIsLoading(false);
        });
    }
        , [i18n.resolvedLanguage])


    return (
        <div>
            {isLoading ? <div>Loading...</div> : null}
            {contact ? (
                <div className="bg-neutral-900/80 flex items-center space-x-4 justify-center mt-10 mb-10">
                    {/* Conteneur pour la photo avec une taille définie et une bordure/ombre pour la démarquer */}
                    <div className="w-48 h-48 rounded-full overflow-hidden shadow-md border-4 border-white">
                        <img
                            src={contact.photos.large}
                            alt="Contact"
                            className="object-cover w-full h-full"
                        />
                    </div>

                    <div className="mt-6">

                        <p className="text-lg text-red-400 italic"> Tarifs personnalisés pour</p>

                        <h2 className="text-2xl font-bold text-white">{contact.prenom} {contact.nom}</h2>
                        <p className="text-lg text-gray-300">{contact.fonction}</p>
                        <p className="text-lg text-gray-300">{contact.societe}</p>
                    </div>


                    {/* Conteneur pour le logo avec une taille définie et potentiellement un fond clair pour le contraste */}
                    {contact.logos.large && (
                        <div className="mt-6 w-48 h-48 bg-gray-100 rounded-md shadow-sm flex items-center justify-center">
                            <img
                                src={contact.logos.large}
                                alt="Logo"
                                className="object-contain w-3/4 h-3/4"
                            />
                        </div>
                    )}


                </div>
            ) : null}
        </div>
    )

}



const Packs = ({ sections, tiers, pageTitle, pageSubtitle }) => {

    const { t, i18n } = useTranslation();

    //const [sections, setSections] = useState([])
    // const [tiers, setTiers] = useState([])
    // const [pageTitle, setPageTitle] = useState('');
    //const [pageSubtitle, setPageSubtitle] = useState('');
    const [boutonAcheter, setBoutonAcheter] = useState(' ')



    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }


    useEffect(() => {

        if (i18n.language === 'fr') {
            //setSections(sections_fr)
            //setTiers(tiers_fr)
            //setPageTitle(' Offres de Participation – Tech4Movies Meetup (Cannes 2025)')
            //setPageSubtitle('Participez à myGlobalVillage – Tech4Movies Meetup, le rendez-vous international des technologies au service du cinéma et de l’audiovisuel au cœur du Marché du Film de Cannes. Bénéficiez d’un accès privilégié, d’une visibilité internationale, de connexions ciblées et d’opportunités business concrètes.')
            setBoutonAcheter('Acheter')
        } else {
            //setSections(sections_en)
            //setTiers(tiers_en)
            //setPageTitle('Participation Offers – Tech4Movies Meetup (Cannes 2025)')
            // setPageSubtitle('Join myGlobalVillage – Tech4Movies Meetup, the international rendezvous of technologies for cinema and audiovisual at the heart of the Cannes Film Market. Benefit from privileged access, international visibility, targeted connections and concrete business opportunities.')
            setBoutonAcheter('Buy')
        }

    }
        , [i18n.language])



    return (
        <Layout>

            {i18n.language}

            <div
                style={{ background: 'linear-gradient(to bottom right, #0a0a0a, #0a0a0a, #b91c1c)' }}
                className="py-24 sm:py-32 min-h-screen bg-gradient-to-br from-neutral-950 via-neutral-900 to-red-700"
            >
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-7xl text-center">
                        <h2 className="text-base/7 font-semibold text-indigo-400 hidden">Pricing</h2>
                        <p className="mt-2 text-5xl font-semibold tracking-tight text-balance text-white sm:text-6xl">
                            {pageTitle}
                        </p>
                    </div>
                    <p className="mx-auto mt-6 max-w-7xl text-center text-lg font-medium text-pretty text-gray-400 sm:text-xl/8">
                        {pageSubtitle}
                    </p>

                    <Coordinateur />

                    {/* xs to lg */}
                    <div className="mx-auto mt-12 max-w-md space-y-8 sm:mt-16 lg:hidden">
                        {tiers.map((tier) => (
                            <section
                                key={tier.id}
                                className={classNames(
                                    tier.mostPopular ? 'rounded-xl bg-white/5 ring-1 ring-white/10 ring-inset' : '',
                                    'p-8',
                                )}
                            >
                                <h3 id={tier.id} className="text-sm/6 font-semibold text-white uppercase ">
                                    {tier.name}
                                </h3>
                                <p className="mt-2 flex items-baseline gap-x-1">
                                    <span className="text-4xl font-semibold text-white">{tier.priceMonthly}</span>
                                    <span className="text-sm font-semibold text-gray-300 hidden">/month</span>
                                </p>
                                <a
                                    href={tier.href}
                                    aria-describedby={tier.id}
                                    className={classNames(
                                        tier.mostPopular
                                            ? 'bg-red-500 text-white hover:bg-red-400 focus-visible:outline-indigo-500'
                                            : 'bg-white/10 text-white hover:bg-white/20 focus-visible:outline-white',
                                        'mt-8 block rounded-md px-3 py-2 text-center text-sm/6 font-semibold focus-visible:outline-2 focus-visible:outline-offset-2',
                                    )}
                                >
                                    Buy plan
                                </a>
                                <ul role="list" className="mt-10 space-y-4 text-sm/6 text-white">
                                    {sections.map((section) => (
                                        <li key={section.name}>
                                            <ul role="list" className="space-y-4">
                                                {section.features.map((feature) =>
                                                    feature.tiers[tier.id] ? (
                                                        <li key={feature.name} className="flex gap-x-3">
                                                            <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-red-400" />
                                                            <span>
                                                                {feature.name}{' '}
                                                                {typeof feature.tiers[tier.id] === 'string' ? (
                                                                    <span className="text-sm/6 text-gray-400">({feature.tiers[tier.id]})</span>
                                                                ) : null}
                                                            </span>
                                                        </li>
                                                    ) : null,
                                                )}
                                            </ul>
                                        </li>
                                    ))}
                                </ul>
                            </section>
                        ))}
                    </div>

                    {/* lg+ */}
                    <div className="isolate mt-20 hidden lg:block">
                        <div className="relative -mx-8">
                            {tiers.some((tier) => tier.mostPopular) ? (
                                <div className="absolute inset-x-4 inset-y-0 -z-10 flex">
                                    <div
                                        style={{ marginLeft: `${(tiers.findIndex((tier) => tier.mostPopular) + 1) * 20}%` }}
                                        aria-hidden="true"
                                        className="flex w-1/5 px-4"
                                    >
                                        <div className="w-full rounded-t-xl border-x border-t border-white/10 bg-white/5" />
                                    </div>
                                </div>
                            ) : null}
                            <table className="w-full table-fixed border-separate border-spacing-x-8 text-left">
                                <caption className="sr-only">Pricing plan comparison</caption>
                                <colgroup>
                                    <col className="w-1/5" />
                                    <col className="w-1/5" />
                                    <col className="w-1/5" />
                                    <col className="w-1/5" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <td />
                                        {tiers.map((tier) => (
                                            <th key={tier.id} scope="col" className="px-6 pt-6 xl:px-8 xl:pt-8">
                                                <div className="text-sm/7 font-semibold text-red-400 uppercase">{tier.name}</div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">
                                            <span className="sr-only">Price</span>
                                        </th>
                                        {tiers.map((tier) => (
                                            <td key={tier.id} className="px-6 pt-2 xl:px-8">
                                                <div className="flex items-baseline gap-x-1 text-white">
                                                    <span className="text-4xl font-semibold">{tier.priceMonthly}</span>
                                                    <span className="text-sm/6 font-semibold hidden">/month</span>
                                                </div>
                                                <a
                                                    href={tier.href}
                                                    className={classNames(
                                                        tier.mostPopular
                                                            ? 'bg-red-700 hover:bg-red-500 focus-visible:outline-indigo-600'
                                                            : 'bg-white/10 hover:bg-white/20 focus-visible:outline-white',
                                                        'mt-8 block rounded-md px-3 py-2 text-center text-sm/6 font-semibold text-white focus-visible:outline-2 focus-visible:outline-offset-2',
                                                    )}
                                                >
                                                    {boutonAcheter}
                                                </a>
                                            </td>
                                        ))}
                                    </tr>
                                    {sections.map((section, sectionIdx) => (
                                        <Fragment key={section.name}>
                                            <tr className="bg-red-700/30">
                                                <th
                                                    scope="colgroup"
                                                    colSpan={5}
                                                    className={classNames(
                                                        sectionIdx === 0 ? 'pt-8' : 'pt-16',
                                                        'pb-4 text-sm/6 font-bold text-white uppercase items-center px-2',
                                                    )}
                                                >
                                                    {section.name}
                                                    <div className="absolute inset-x-8 mt-4 h-px bg-white/10" />
                                                </th>
                                            </tr>
                                            {section.features.map((feature) => (
                                                <tr key={feature.name}>
                                                    <th scope="row" className="py-4 text-sm/6 font-normal text-white">
                                                        {feature.name}
                                                        <div className="absolute inset-x-8 mt-4 h-px bg-white/5" />
                                                    </th>
                                                    {tiers.map((tier) => (
                                                        <td key={tier.id} className="px-6 py-4 xl:px-8">
                                                            {typeof feature.tiers[tier.id] === 'string' ? (
                                                                <div className="text-center text-sm/6 text-white">
                                                                    {
                                                                        HTMLReactParser(feature.tiers[tier.id])}</div>
                                                            ) : (
                                                                <>
                                                                    {feature.tiers[tier.id] === true ? (
                                                                        <CheckIcon aria-hidden="true" className="mx-auto size-5 text-red-400" />
                                                                    ) : (
                                                                        <MinusIcon aria-hidden="true" className="mx-auto size-5 text-white" />
                                                                    )}

                                                                    <span className="sr-only">
                                                                        {feature.tiers[tier.name] === true ? 'Included' : 'Not included'} in {tier.name}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Packs